export default function isArrayLike(value) {
    return value &&
        typeof value.length === 'number' &&
        value.length >= 0 &&
        value.length % 1 === 0;
}



// WEBPACK FOOTER //
// ./~/async-es/internal/isArrayLike.js